import * as React from "react"

import { PRODUCTS_REVIEW_ROUTES, USER_ROLE } from "@constants"
import AppLayout from "Layout"
import ProductsReviewPage from "./index"


export const ProductsReviewRoutes = {
    path: PRODUCTS_REVIEW_ROUTES.PATH,
    title: PRODUCTS_REVIEW_ROUTES.TITLE,
    icon: 'boxes-stacked',
    iconWeight: 'light',
    element: <AppLayout />,
    description: PRODUCTS_REVIEW_ROUTES.SUBTITLE,
    access: USER_ROLE.ADMIN,
    children: [{
        element: <ProductsReviewPage />, 
        index: true
    }]
}
